import React, { useEffect } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
import { useSearchParams } from "react-router-dom";
import { toast } from "react-toastify";

import { HiExternalLink } from "react-icons/hi";

import CmsEditBanner from "../helpers/cms/CmsEditBanner";
import { useCmsHook } from "../helpers/cms/cmsHook";
import { cmsConstructor } from "../helpers/cms/cmsConstructor";
import { fetchStatus } from "../store/slice/preferenceSlice";

import msbcLogo from "../assets/images/msbcLogo.svg";

function MSBCExtension() {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();
  const { cmsInstance, setCmsInstance } = useCmsHook();
  // states
  const { isMsbcExtensionInstalled } = useSelector((state) => state.preference);

  /**
   * This function used for installing the MSBC extension
   */
  const onInstallMSBC = async () => {
    try {
      // const tenantId = searchParams.get("tenantId");
      const account = searchParams.get("account");
      window.open(
        `https://www.google.com/?account=${account}&path=${
          window.location.pathname.split("/")[1]
        }`,
        "_self"
      );
    } catch (error) {
      console.log(error);
      let errorMessage;
      if (error.response && error.response.data.message)
        errorMessage = error.response.data.message;
      else errorMessage = error.message;
      toast.error(errorMessage);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
    const account = searchParams.get("account");
    if (account) {
      dispatch(fetchStatus(account));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const fetchCmsInstance = async () => {
      const cmsObj = await cmsConstructor();
      setCmsInstance(cmsObj);
    };
    fetchCmsInstance();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="page-bg-container w-100">
      {window.location.pathname === "/extension" && (
        <div className="d-flex flex-row justify-content-center">
          <CmsEditBanner />
        </div>
      )}
      <div className="page-bg-container d-flex flex-column justify-content-center align-items-center">
        <Row className="d-flex flex-row justify-content-center align-items-center h-100 w-100 px-2">
          <Col sm={10} md={6} lg={3} className="oauth-card px-0">
            <div>
              <div className="oauth-card-heading-container">
                {cmsInstance &&
                  cmsInstance.showRichText(
                    "cmsContent.extension.heading",
                    "oauth-card-heading"
                  )}
              </div>
              <div className="px-4 pt-5">
                <div className="oauth-card-logos-container">
                  <img src={msbcLogo} alt="msbc logo" />
                </div>
                {cmsInstance &&
                  cmsInstance.showRichText(
                    "cmsContent.extension.description",
                    "oauth-card-para mt-2"
                  )}
              </div>
            </div>

            <div className="px-4 d-flex flex-column pb-4">
              <Button
                className="oauth-card-connect"
                disabled={isMsbcExtensionInstalled}
                onClick={() => onInstallMSBC()}
              >
                {isMsbcExtensionInstalled ? (
                  <span>Installed</span>
                ) : (
                  <>
                    <span>Install Business Central Extension</span>
                    <HiExternalLink
                      className="oauth-card-hyperlink"
                      size={17}
                    />
                  </>
                )}
              </Button>
            </div>
          </Col>
        </Row>
      </div>
    </div>
  );
}

export default MSBCExtension;
